"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mobx_1 = require("mobx");
var localforage_1 = __importDefault(require("localforage"));
/**************************************** PROJECT MODULES *****************************************/
var store_1 = require("./store");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('TokenStore', shared_1.Styles.hatBlock);
/********************************************* CONFIG *********************************************/
/*
 * Store value in localStorage at this property
 */
var ACCESS_TOKEN = store_1.AS_TAG + " accessToken";
/********************************************* EXPORT *********************************************/
/**
 * @export TokenStore - Store & handle token data
 */
var TokenStore = /** @class */ (function () {
    function TokenStore() {
        var _this = this;
        // Local token data (handled by getter & setter for 'token' property)
        this._token = '';
        // Token status
        this.hasTokenInitLoaded = false;
        this.isTokenDeleting = false;
        this.hasTokenBeenDeleted = false;
        /**
         * If token not present, set from local storage
         */
        this.initialTokenSet = function () {
            if (!_this._token && !_this.hasTokenInitLoaded) {
                return localforage_1.default.getItem(ACCESS_TOKEN).then(mobx_1.action(function (tkn) {
                    _this._token = tkn;
                    _this.hasTokenInitLoaded = true;
                    _this.hasTokenBeenDeleted = false;
                    log.info("Store#setToken->getItem [END]: tkn: " + tkn + "; this._token:", _this._token);
                    return _this._token;
                }));
            }
            return Promise.resolve(_this._token);
        };
        /**
         * Set the access token in the cache [ASYNC]
         */
        this.setCacheToken = mobx_1.action(function (cleanToken) {
            return localforage_1.default.setItem(ACCESS_TOKEN, cleanToken).then(function (res) {
                if (_this._token !== '')
                    _this.hasTokenBeenDeleted = false;
                log.info("Store#setToken->localforage.setItem end: res:", res);
            });
        });
        /**
         * Log the token and the current token state before
         */
        this.logPreSetTokenState = function (srcFn, token) {
            // prettier-ignore
            log.info("Store#" + srcFn + ":", "\n|  token:", token, "\n|  this._token", _this._token, "\n|  this.hasTokenInitLoaded:", _this.hasTokenInitLoaded, "\n|  this.isTokenDeleting:", _this.isTokenDeleting, "\n|  this.hasTokenBeenDeleted:", _this.hasTokenBeenDeleted);
        };
        /**
         * Set the access token
         * Delete token if no value or empty string given
         * @return {Promise<void>} When deletion completes, promise resolves
         */
        this.setToken = mobx_1.action(function (token) {
            _this.logPreSetTokenState('setToken (start)', token);
            // If deletion in progress, return immediately
            if (_this.isTokenDeleting)
                return Promise.resolve();
            // If new token present, set in memory & local storage; delete token if empty
            if (token !== '' && token !== null && typeof token !== 'undefined') {
                var cleanToken = mobx_1.toJS(token).replace(/^ *,*/, '');
                _this._token = cleanToken;
                return _this.setCacheToken(cleanToken);
            }
            else {
                return _this.deleteToken();
            }
        });
        /**
         *  Delete the auth accessToken (should lock user out of app)
         */
        this.deleteToken = mobx_1.action(function () {
            _this._token = '';
            _this.isTokenDeleting = true;
            return localforage_1.default.setItem(ACCESS_TOKEN, '').then(mobx_1.action(function (res) {
                log.info("Store#deleteToken :: localforage set accessToken cb: res:", res);
                _this.isTokenDeleting = false;
                _this.hasTokenBeenDeleted = true;
            }));
        });
    }
    Object.defineProperty(TokenStore.prototype, "token", {
        /**
         * @returns {string} access token prefixed with 'accessToken=' for use in Cookie headers
         */
        get: function () {
            log.verbose("Store#get token :: this._token (entry):", this._token);
            // If token in process of deletion or not present, return empty string
            if (this.isTokenDeleting || !this._token)
                return '';
            // Prefix with 'accessToken='
            return "accessToken=" + mobx_1.toJS(this._token).replace(/^(accessToken=)+/g, '');
        },
        /**
         * Set the accessToken for authentication
         */
        set: function (tkn) {
            this.setToken(tkn);
        },
        enumerable: true,
        configurable: true
    });
    TokenStore.Instance = null;
    /**
     * @constructor
     * Factory method (true constructor)
     */
    TokenStore.new = function () {
        if (!TokenStore.Instance) {
            TokenStore.Instance = new TokenStore();
            log.verbose("TokenStore created: ", TokenStore.Instance);
        }
        return TokenStore.Instance;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], TokenStore.prototype, "_token", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenStore.prototype, "hasTokenInitLoaded", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenStore.prototype, "isTokenDeleting", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenStore.prototype, "hasTokenBeenDeleted", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], TokenStore.prototype, "token", null);
    return TokenStore;
}());
exports.TokenStore = TokenStore;
//# sourceMappingURL=token-store.js.map